let currentEnvironment

if (typeof REACT_APP_ENVIRONMENT_CONFIGURATION !== 'undefined') {
  const environmentConfiguration = JSON.parse(REACT_APP_ENVIRONMENT_CONFIGURATION)

  const domain = window.location.hostname.toLowerCase()
  currentEnvironment = environmentConfiguration.centres.find(centre => centre.domains.indexOf(domain) !== -1)
}

export const get = (key) => currentEnvironment !== undefined ? currentEnvironment[key] : ''



// WEBPACK FOOTER //
// ./lib/config.js